<h1 class="center">Paramètres linge d'hébergement</h1>

<div class="container flex flex-col m-auto">
	<div *ngIf="loading; else articlesTemplate" class="flex justify-center">
		<mat-spinner></mat-spinner>
	</div>
	<ng-template #articlesTemplate>
		<div class="flex justify-center">
			<button mat-stroked-button class="statistics" (click)="statistics()">
				<div>
					Statistiques
				</div>
			</button>
		</div>

		<form *ngIf="!loading" [formGroup]="commandeSettingsForm" class="w-full">
			<div *ngIf="client.is_livraison_commande">
				<h2>Paramétrage global :</h2>
				<mat-slide-toggle class="pb-2.5 pr-5" formControlName="cptLingeries" (change)="onChangeComptage()"
					color="primary">
					Par lingerie
				</mat-slide-toggle>
				<mat-slide-toggle class="pb-2.5" *ngIf="commandeSettingsForm.value.cptLingeries"
					(change)="onChangeComptageJour()" formControlName="cptDotation" color="primary">
					Dotation par jour de livraison
				</mat-slide-toggle>

				<div *ngIf="!commandeSettingsForm.value.cptDotation">
					<h3>Limite de commande :</h3>
					<mat-form-field appearance="fill" class="example-full-width">
						<mat-label>Taux</mat-label>
						<input type="number" matInput maxlength="2" placeholder="Ex. 80%" formControlName="coef">
						<span matTextSuffix>%</span>
					</mat-form-field>
					<mat-slide-toggle *ngIf="commandeSettingsForm.value.cptLingeries" class="pl-5"
						formControlName="taux" color="primary">Application du taux</mat-slide-toggle>

					<h3 *ngIf="!commandeSettingsForm.value.cptLingeries"> Multiple MAB Journalier : </h3>
					<h3 *ngIf="commandeSettingsForm.value.cptLingeries"> Multiple Dotation Journalier : </h3>
					<div class="flex w-full">
						<mat-form-field appearance="fill">
							<mat-label>Lundi</mat-label>
							<input type="number" matInput maxlength="1" placeholder="Entre 0 et 7"
								formControlName="lundi" (input)="checkValue($event, 'lundi')">
						</mat-form-field>
						<mat-form-field appearance="fill">
							<mat-label>Mardi</mat-label>
							<input type="number" matInput maxlength="1" placeholder="Entre 0 et 7"
								formControlName="mardi" (input)="checkValue($event, 'mardi')">
						</mat-form-field>
						<mat-form-field appearance="fill">
							<mat-label>Mercredi</mat-label>
							<input type="number" matInput maxlength="1" placeholder="Entre 0 et 7"
								formControlName="mercredi" (input)="checkValue($event, 'mercredi')">
						</mat-form-field>
						<mat-form-field appearance="fill">
							<mat-label>Jeudi</mat-label>
							<input type="number" matInput maxlength="1" placeholder="Entre 0 et 7"
								formControlName="jeudi" (input)="checkValue($event, 'jeudi')">
						</mat-form-field>
						<mat-form-field appearance="fill">
							<mat-label>Vendredi</mat-label>
							<input type="number" matInput maxlength="1" placeholder="Entre 0 et 7"
								formControlName="vendredi" (input)="checkValue($event, 'vendredi')">
						</mat-form-field>
						<mat-form-field appearance="fill">
							<mat-label>Samedi</mat-label>
							<input type="number" matInput maxlength="1" placeholder="Entre 0 et 7"
								formControlName="samedi" (input)="checkValue($event, 'samedi')">
						</mat-form-field>
					</div>
				</div>
			</div>
			<div *ngIf="!client.is_livraison_commande">
				<h2>Paramétrage global :</h2>
				<mat-slide-toggle class="pb-2.5" formControlName="enabledComplement" color="primary">
					Avec complement
				</mat-slide-toggle>
			</div>

			<h2> Paramétrage des articles : </h2>
			<mat-slide-toggle class="pb-5" formControlName="cond" color="primary">Affichage du
				conditionnement</mat-slide-toggle>
			<div *ngIf="!commandeSettingsForm.value.cptLingeries && client.is_livraison_commande">
				<table class="styled-table">
					<thead>
						<tr>
							<th>Article</th>
							<th *ngIf='isCondActive()' class="configuration">Conditionnement</th>
							<th class="configuration">Stock</th>
							<th class="configuration">MAB</th>
							<th class="w-5"></th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let article of commandeSettingsArticles">
							<td>{{ article.article.designation }}</td>
							<td *ngIf='isCondActive()'>
								<mat-form-field class="configuration">
									<mat-label></mat-label>
									<input type="text" matInput value="{{ article.qte_conditionnement }}"
										(change)="updateArticleConditionnement(article, $event)">
								</mat-form-field>
							</td>
							<td>
								{{ article.qte_stock }}
								<mat-icon *ngIf="article?.qte_stock == 0" class="warning-MAB"
									matTooltip="Le client ne pourra pas commander cet article tant que « Qt. Stock » égale à 0 dans Hermine !">
									warning
								</mat-icon>
							</td>
							<td>
								{{ article.qte_mab }}
								<mat-icon *ngIf="article?.qte_mab == 0" class="warning-MAB"
									matTooltip="Le client ne pourra pas commander cet article tant que « Qt. MAB » égale à 0 dans Hermine !">
									warning
								</mat-icon>
							</td>
							<td class="icon-click">
								<mat-icon matTooltip="Enlever l'article" (click)="removeArticle(article, false)">
									delete
								</mat-icon>
							</td>
						</tr>
					</tbody>
				</table>
				<mat-card-actions class="commande-settings-articles-add">
					<button mat-raised-button (click)="openDialog()">
						<div class="flex justify-center items-center">
							<mat-icon>add_circle_outline</mat-icon>
						</div>
						<div>
							Ajouter un article
						</div>
					</button>
				</mat-card-actions>
			</div>
			<div *ngIf="!client.is_livraison_commande || commandeSettingsForm.value.cptLingeries"
				class="flex gap-2.5 mb-2.5">
				<button mat-raised-button color="primary" class="first"
					(click)="ajoutLingerie()"><mat-icon>add_circle_outline</mat-icon>Ajouter une lingerie
				</button>
				<button mat-raised-button color="orange"
					(click)="activateLingeries()"><mat-icon>refresh</mat-icon>Réactiver une lingerie
				</button>
			</div>
			<div *ngIf="!client.is_livraison_commande || commandeSettingsForm.value.cptLingeries">
				<mat-form-field class="lingeries">
					<mat-select placeholder="Sélectionner une lingerie" formControlName="lingerie">
						<mat-option *ngFor="let lingerie of lingeries"
							[value]="lingerie.id">{{lingerie.libelle}}</mat-option>
					</mat-select>
					<mat-error *ngIf="commandeSettingsForm.get('lingerie').hasError('required')">Vous devez renseigner
						une lingerie</mat-error>
				</mat-form-field>
				<button mat-raised-button color="primary" class="ml-2.5" (click)="updateLingerie()"
					*ngIf="commandeSettingsForm.value.lingerie != null"><mat-icon>edit</mat-icon>Editer la
					lingerie
				</button>
				<div *ngIf="loadingDotations" class="flex justify-center">
					<mat-spinner></mat-spinner>
				</div>
				<div *ngIf="dotations && !loadingDotations">
					<h3 *ngIf="commandeSettingsForm.value.cptDotation">Liste des dotations par jour et par articles :
					</h3>
					<table class="styled-table">
						<thead>
							<tr>
								<th>Article</th>
								<th *ngIf='isCondActive()' class="configuration">Conditionnement</th>
								<th *ngIf="client.is_livraison_commande" class="configuration">Stock</th>
								<th *ngIf="client.is_livraison_commande && !commandeSettingsForm.value.cptDotation"
									class="dotationJ">Dotation journalière</th>
								<ng-container
									*ngIf="!client.is_livraison_commande || commandeSettingsForm.value.cptDotation">
									<th class="w-16" *ngFor="let delivery of commandeSettingsDeliveries">
										{{getJourLivraison(delivery)}}</th>
								</ng-container>
								<th class="w-5"></th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let article of commandeSettingsArticles">
								<td>{{ article.article.designation }}</td>
								<td *ngIf='isCondActive()'>
									<mat-form-field class="configuration">
										<mat-label></mat-label>
										<input type="text" matInput value="{{ article.qte_conditionnement }}"
											(change)="updateArticleConditionnement(article, $event)">
									</mat-form-field>
								</td>
								<td *ngIf="client.is_livraison_commande">
									{{ article.qte_stock }}
									<mat-icon *ngIf="article?.qte_stock == 0" class="warning-MAB"
										matTooltip="Le client ne pourra pas commander cet article tant que « Qt. Stock » égale à 0 dans Hermine !">
										warning
									</mat-icon>
								</td>
								<td *ngIf="client.is_livraison_commande && !commandeSettingsForm.value.cptDotation">
									<mat-form-field class="dotationJ">
										<mat-label></mat-label>
										<input type="text" matInput min=0 [value]="getDotation(article, 0)" #txtInput
											(keydown.enter)="txtInput.blur()"
											(change)="updateArticleDotation(article, $event, 0)">
									</mat-form-field>
								</td>
								<ng-container
									*ngIf="!client.is_livraison_commande || commandeSettingsForm.value.cptDotation">
									<td *ngFor="let delivery of commandeSettingsDeliveries">
										<mat-form-field class="w-20">
											<mat-label></mat-label>
											<input type="text" matInput min=0
												[value]="getDotation(article, delivery.jrs_relivraison_lp)" #txtInput
												(keydown.enter)="txtInput.blur()"
												(change)="updateArticleDotation(article, $event, delivery.jrs_relivraison_lp)">
										</mat-form-field>
									</td>
								</ng-container>
								<td class="icon-click">
									<mat-icon matTooltip="Enlever l'article" (click)="removeArticle(article, false)">
										delete
									</mat-icon>
								</td>
							</tr>
						</tbody>
					</table>

					<mat-card-actions class="commande-settings-articles-add">
						<button mat-raised-button (click)="openDialog()">
							<div class="flex justify-center items-center">
								<mat-icon>add_circle_outline</mat-icon>
							</div>
							<div>
								Ajouter un article
							</div>
						</button>
					</mat-card-actions>
				</div>
			</div>
			<mat-card-actions class="pb-5">
				<button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="saving">Enregistrer</button>
			</mat-card-actions>
		</form>
	</ng-template>
</div>